import React from 'react';
import PropTypes from 'prop-types';

const ErrorPage = ({ route: { status } }) => (
  <div data-module-name="axp-error-message" className="flex flex-column flex-align-center text-align-center">
    <span className="icon dls-icon-warning dls-color-warning" />
    <div>
      <h4 className="dls-gray-05 heading-4 margin-1-tb">
        {
          status === 404
            ? 'Page Not Found'
            : 'Loading Error'
        }
      </h4>
      <p className="dls-body-3">
        {
          status === 404
            ? 'We\'re sorry, but we could not find a page matching your request. Please check that you have entered the correct address. You can also return to the previous page, or go to the homepage.'
            : 'Sorry, we are unable to load this page at this time. Please try again later.'
        }
      </p>
    </div>
  </div>
);

ErrorPage.propTypes = {
  route: PropTypes.shape({
    message: PropTypes.string,
    status: PropTypes.number,
  }).isRequired,
};

export default ErrorPage;
